@if (error) {
    <app-error-ficha [mensaje]="error" (reintentar)="loadData()" (volver)="volverAlListado()"></app-error-ficha>
} @else if (showEdit) {
    <div class="page page--form">
        <button type="button" class="back-link mb-2" (click)="showEdit=false"><i class="bi bi-arrow-left" aria-hidden="true"></i>Volver a la ficha</button>
        <app-page-header titulo="Editar asociación" [descripcion]="item?.nombre ?? ''" icono="bi-pencil-square" seccion="asociaciones"></app-page-header>
        <form [formGroup]="editForm" (ngSubmit)="saveAssociation()" class="stack">
            <section class="panel" aria-labelledby="edit-generales">
                <h2 id="edit-generales" class="panel__title">Datos generales</h2>
                <div class="form-grid">
                    @for (campo of [['nombre','Nombre','text'],['cif','CIF','text'],['lema','Lema','text'],['anyo_fundacion','Año de fundación','number'],['telefono','Teléfono','text'],['email','Correo electrónico','text']]; track campo[0]) {
                        <div>
                            <label class="form-label" [for]="'asoc-' + campo[0]">{{ campo[1] }}</label>
                            <input class="form-control" [id]="'asoc-' + campo[0]" [type]="campo[2]" [formControlName]="campo[0]">
                        </div>
                    }
                </div>
            </section>
            <section class="panel" aria-labelledby="edit-ubicaciones">
                <h2 id="edit-ubicaciones" class="panel__title">Ubicaciones</h2>
                <app-location-picker label="Domicilio social" [value]="location('direccion')" (locationChange)="setLocation('direccion', $event)"></app-location-picker>
                <app-location-picker label="Sede social" [value]="location('sede_direccion')" (locationChange)="setLocation('sede_direccion', $event)"></app-location-picker>
                @if (isFoguera()) {
                    <app-location-picker label="Lugar de plantà de la foguera" [value]="location('ubicacion_monumento')" (locationChange)="setLocation('ubicacion_monumento', $event)"></app-location-picker>
                    <app-location-picker label="Lugar de plantà de la foguera infantil" [value]="location('ubicacion_foguera_infantil')" (locationChange)="setLocation('ubicacion_foguera_infantil', $event)"></app-location-picker>
                    <app-location-picker label="Lugar de ubicación del racó" [value]="location('ubicacion_raco')" (locationChange)="setLocation('ubicacion_raco', $event)"></app-location-picker>
                } @else {
                    <app-location-picker label="Lugar de plantà de la portalada" [value]="location('ubicacion_portada')" (locationChange)="setLocation('ubicacion_portada', $event)"></app-location-picker>
                    <app-location-picker label="Lugar de plantà de la barraca" [value]="location('ubicacion_barraca')" (locationChange)="setLocation('ubicacion_barraca', $event)"></app-location-picker>
                }
            </section>
            <div class="form-actions">
                <button class="btn btn-primary" [disabled]="saving">@if (saving) { Guardando… } @else { <i class="bi bi-check-lg" aria-hidden="true"></i>Guardar }</button>
                <button type="button" class="btn btn-outline-secondary" (click)="showEdit=false">Cancelar</button>
            </div>
        </form>
        <app-estado-acceso-editor [asociacion]="item" (estadoCambiado)="onEstadoCambiado($event)"></app-estado-acceso-editor>
    </div>
} @else {
    <div class="page">
        @if (loading) {
            <app-spinner [fullscreen]="false"></app-spinner>
        } @else {
            <section class="ficha-hero" data-seccion="asociaciones" aria-labelledby="ficha-titulo">
                <div class="ficha-hero__back">
                    <button type="button" class="back-link" (click)="goBack({mode: 'showItem', item: parent, type: 'Ejercicios'})"><i class="bi bi-arrow-left" aria-hidden="true"></i>Volver</button>
                </div>
                <div class="ficha-hero__top">
                    @if (tieneFoto(item.img)) {
                        <img [src]="filesBasePath + item.img" class="ficha-hero__photo" [alt]="'Imagen de ' + item.nombre" width="96" height="96">
                    } @else if(!item.ejercicio) {
                        <img src="assets/img/default.png" class="ficha-hero__photo" alt="Sin imagen" width="96" height="96">
                    }
                    <div class="ficha-hero__id">
                        <h1 id="ficha-titulo">{{ item.nombre | titlecase }}</h1>
                        <app-estado-asociacion [asociacion]="item"></app-estado-asociacion>
                    </div>
                    <div class="ficha-hero__actions">
                        @if (viewMode === ViewModeAsociado.CHANGE_PASSWORD) {
                            <button type="button" class="btn btn-outline-secondary" (click)="viewMode = ViewModeAsociado.CONTACT"><i class="bi bi-person-vcard" aria-hidden="true"></i>Volver a la ficha</button>
                        } @else if (puedeEditar || puedeCambiarClaves || puedeGestionarEstado) {
                            <div class="dropdown">
                                <button class="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-testid="boton-acciones">
                                    <i class="bi bi-three-dots-vertical" aria-hidden="true"></i>Acciones
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end" data-testid="menu-acciones">
                                    @if (puedeEditar) {
                                        <li><button type="button" class="dropdown-item" data-testid="accion-editar" (click)="editItem()"><i class="bi bi-pencil-square" aria-hidden="true"></i>Editar datos</button></li>
                                    }
                                    @if (puedeCambiarClaves) {
                                        <li><button type="button" class="dropdown-item" data-testid="accion-claves" (click)="viewMode = ViewModeAsociado.CHANGE_PASSWORD"><i class="bi bi-key-fill" aria-hidden="true"></i>{{ esCuentaPropia ? 'Cambiar mi contraseña' : 'Cambiar claves' }}</button></li>
                                    }
                                    @if (puedeGestionarEstado) {
                                        <li><button type="button" class="dropdown-item" data-testid="accion-estado" (click)="abrirEstado()"><i class="bi bi-toggles" aria-hidden="true"></i>Estado y acceso</button></li>
                                        <li><a class="dropdown-item" data-testid="accion-administracion" routerLink="/administracion/asociaciones"><i class="bi bi-list-check" aria-hidden="true"></i>Gestionar varias asociaciones</a></li>
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                </div>
                @if (viewMode !== ViewModeAsociado.CHANGE_PASSWORD) {
                    <div class="tabs" role="tablist" aria-label="Secciones de la ficha" appTabsNav>
                        <button type="button" role="tab" class="tab" id="tab-info" [attr.aria-selected]="viewMode === ViewModeAsociado.INFO" [attr.tabindex]="viewMode === ViewModeAsociado.INFO ? 0 : -1" (click)="handleClick(ViewModeAsociado.INFO)">Información</button>
                        <button type="button" role="tab" class="tab" id="tab-contacto" [attr.aria-selected]="viewMode === ViewModeAsociado.CONTACT" [attr.tabindex]="viewMode === ViewModeAsociado.CONTACT ? 0 : -1" (click)="handleClick(ViewModeAsociado.CONTACT)">Contacto</button>
                        <button type="button" role="tab" class="tab" id="tab-asociados" [attr.aria-selected]="viewMode === ViewModeAsociado.ASOCIADOS" [attr.tabindex]="viewMode === ViewModeAsociado.ASOCIADOS ? 0 : -1" (click)="handleClick(ViewModeAsociado.ASOCIADOS)">Asociados</button>
                    </div>
                }
            </section>

            @if (viewMode === ViewModeAsociado.CHANGE_PASSWORD) {
                @if (esCuentaPropia) {
                    <app-update-password [item]="item" [type]="ItemType.ASOCIACIONES" [functionSelected]="FunctionsAvailable.asociacionesPut"></app-update-password>
                } @else if (puedeRestablecer) {
                    <app-restablecer-password tipo="asociacion" [cuenta]="{ id: item.id, nombre: item.nombre }"></app-restablecer-password>
                }
            }
            @if (viewMode === ViewModeAsociado.INFO) {
                <div role="tabpanel" aria-labelledby="tab-info"><dl class="data-grid">
                    <div class="data-item">
                        <dt><i class="bi bi-person-vcard" aria-hidden="true"></i>CIF</dt>
                        <dd [class.is-empty]="item.cif === null">{{ item.cif !== null ? item.cif : 'Sin definir' }}</dd>
                    </div>
                    <div class="data-item">
                        <dt><i class="bi bi-chat-heart-fill" aria-hidden="true"></i>Lema</dt>
                        <dd [class.is-empty]="item.lema === null">{{ item.lema !== null ? item.lema : 'Sin definir' }}</dd>
                    </div>
                    <div class="data-item">
                        <dt><i class="bi bi-cake2-fill" aria-hidden="true"></i>Año de fundación</dt>
                        <dd [class.is-empty]="item.anyo_fundacion === null">{{ item.anyo_fundacion !== null ? item.anyo_fundacion : 'Sin definir' }}</dd>
                    </div>
                </dl></div>
            }
            @if (viewMode === ViewModeAsociado.CONTACT) {
                <div role="tabpanel" aria-labelledby="tab-contacto"><dl class="data-grid">
                    <div class="data-item">
                        <dt><i class="bi bi-phone-fill" aria-hidden="true"></i>Teléfono</dt>
                        <dd [class.is-empty]="item.telefono === null">{{ item.telefono !== null ? item.telefono : 'Sin definir' }}</dd>
                    </div>
                    <div class="data-item">
                        <dt><i class="bi bi-envelope-fill" aria-hidden="true"></i>e-mail</dt>
                        <dd [class.is-empty]="item.email === null">{{ item.email !== null ? item.email : 'Sin definir' }}</dd>
                    </div>
                    <div class="data-item">
                        <dt><i class="bi bi-pin-map-fill" aria-hidden="true"></i>Dirección</dt>
                        <dd [class.is-empty]="item.direccion === null">{{ item.direccion !== null ? item.direccion : 'Sin definir' }}</dd>
                    </div>
                    <div class="data-item">
                        <dt><i class="bi bi-geo-fill" aria-hidden="true"></i>Código postal</dt>
                        <dd [class.is-empty]="item.codigo_postal === null">{{ item.codigo_postal !== null ? item.codigo_postal : 'Sin definir' }}</dd>
                    </div>
                </dl></div>
            }
            @if (viewMode === ViewModeAsociado.ASOCIADOS) {
                <section class="panel" role="tabpanel" aria-labelledby="tab-asociados">
                    <div class="panel-head">
                        <h2 class="panel__title" data-testid="asociados-titulo">Asociados - {{asociados.length}}@if (ejercicioAsociados) { <small class="text-muted fw-normal"> (ejercicio {{ ejercicioAsociados }})</small> }</h2>
                        <div class="search-field">
                            <i class="bi bi-search" aria-hidden="true"></i>
                            <input type="search" class="form-control" aria-label="Buscar asociado" [formControl]="searchControl" autocomplete="off" placeholder="Nombre, apellido o DNI/NIE/SIP" (input)="filterItems($event)">
                        </div>
                    </div>
                    @if (asociadosCargando) {
                        <div class="loading-box" role="status" data-testid="asociados-cargando">
                            <span class="visually-hidden">Cargando asociados…</span>
                            <div class="skeleton skeleton--card" aria-hidden="true"></div>
                            <div class="skeleton skeleton--card" aria-hidden="true"></div>
                        </div>
                    } @else if (asociadosError) {
                        <div class="alert alert-warning d-flex flex-wrap align-items-center justify-content-between gap-2 mb-0" role="alert" data-testid="asociados-error">
                            <span>{{ asociadosError }}</span>
                            <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="asociados-reintentar" (click)="cargarAsociados()">Reintentar</button>
                        </div>
                    } @else if (asociados.length === 0) {
                        <p class="empty-inline" data-testid="asociados-vacio">No hay asociados registrados en este ejercicio</p>
                    } @else {
                        <app-listado
                            [marginPagination]="false"
                            [showFilter]="false"
                            [itemsPerPage]="15"
                            [items]="asociadosToShow"
                            [type]="ItemType.ASOCIADOS"
                            (openItem)="null"
                        ></app-listado>
                    }
                </section>
            }
        }
    </div>
}
